export default {
	propose: 'Create your own event and sell\ntickets online using teeko services!',
	description: 'The unsurpassed experience\nbegins with a ticket purchase!',
	moreEvents: 'Show More Events',
	search: 'Search'
}
